export enum ReadingStatus {
  Assigned = 0,
  Submitted = 1,
  Failed = 2,
  Rejected = 3,
  Inaccessible = 4,
  Inoperable = 5,
}

export enum FailedReadingOptions {
    RealReading = 1,
    AIReading = 2,
    Retake = 3
}